module.exports = __webpack_public_path__ + "img/covea.36823481.png";